import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
const HTMLElement = document.getElementById("root");

ReactDOM.createRoot(HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
